export const FUSE_OPTIONS = {
  findAllMatches: false,
  shouldSort: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  includeScore: false,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    'name'
  ]
};
